export default __webpack_public_path__ + "static/media/swing-carousel.e859c9f6.jpg";